(function() {
  if (App.angularApp == null) {
    return;
  }

  App.angularApp.directive('mfMentionContainer', function() {
    return {
      restrict: 'EA',
      scope: {
        text: '=model',
        is_open: '=toggle',
        pattern: '=pattern'
      },
      controller: [
        '$scope', function($scope) {
          this.setPattern = (function(_this) {
            return function(val, is_open) {
              $scope.pattern = val;
              return $scope.is_open = is_open;
            };
          })(this);
          this.setText = (function(_this) {
            return function(val) {
              $scope.text = val;
              return $scope.$apply();
            };
          })(this);
          this.get = (function(_this) {
            return function(prop) {
              return $scope[prop];
            };
          })(this);
          return this;
        }
      ]
    };
  });

}).call(this);
